import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Button,
  Circle,
  Icon,
  Text,
  VStack,
} from '@chakra-ui/react';

import { useNavigate } from 'react-router-dom';

import * as fp from 'lodash/fp';

import { IoReceiptOutline } from 'react-icons/io5';

type UnableGroupNoticeModalProps = {
  isOpen: boolean;
};

export default function UnableGroupNoticeModal({ isOpen }: UnableGroupNoticeModalProps) {
  const navigate = useNavigate();

  const displayData = {
    title: '團購已結束',
    description: (
      <Text textAlign="center" fontSize="sm">
        本次團購已經結束！
        <br />
        建議也可以自己點餐喔
      </Text>
    ),
    icon: IoReceiptOutline,
  };
  //  fp.cond([
  // [
  //   fp.eq(CartStatus.CANCELED),
  //   fp.always({
  //     title: '團購已取消',
  //     description: (
  //       <Text textAlign="center" fontSize="sm">
  //         抱歉，此次團購已經取消
  //         <br />
  //         建議也可以自己點餐喔
  //       </Text>
  //     ),
  //     icon: AiOutlineFrown,
  //   }),
  // ],
  // [
  //   fp.T,
  //   fp.always({
  //     title: '',
  //     description: <Text></Text>,
  //     icon: AiOutlineFrown,
  //   }),
  // ],
  // ])(cartStatus);

  return (
    <Modal size="sm" isCentered isOpen={isOpen} onClose={() => {}} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <VStack>
            <Circle size="12" bgColor="primaryLight">
              <Icon as={displayData.icon} boxSize="2rem" color="secondary" />
            </Circle>
            <Text fontWeight="bold">{displayData.title}</Text>
            {displayData.description}
          </VStack>
        </ModalBody>
        <ModalFooter p={0} borderTopWidth="1px">
          <Button variant="unstyled" isFullWidth fontWeight="normal" onClick={() => navigate('/')}>
            前往訂餐網站
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
